import { Link, useLocation } from "react-router-dom";

import LogoImage from "../../assets/image/brand.png";

const Sidebar = () => {
  const currentLink = useLocation();
  return (
    <div
      className={
        "py-[35px] px-[7px] w-[240px] flex flex-col items-center border border-blue-500 bg-slate-800"
      }
    >
      <img src={LogoImage} alt="mybranz" className="px-[39px] h-[37px]" />
      <div className="my-6 px-[36px] h-0 w-3/4 border border-neutral-200" />
      <div className="flex-1 w-full flex flex-col gap-y-4">
        <MenuItem
          text={"+ Add Brand"}
          link={"/admin"}
          isActive={currentLink.pathname === "/admin"}
        />
        <MenuItem
          text={"+ Send Notification"}
          link={"/admin/notification"}
          isActive={currentLink.pathname === "/admin/notification"}
        />
        <MenuItem
          text={"+ Add Reward Item"}
          link={"/admin/reward"}
          isActive={currentLink.pathname === "/admin/reward"}
        />
      </div>
    </div>
  );
};

export default Sidebar;

/**
 *
 * @param {any} Icon - svg component to render at left
 * @param {string} text - link text
 * @param {string} link - routing url
 * @param {boolean} isActive
 */
const MenuItem = ({
  Icon,
  text,
  link,
  isActive,
}: {
  Icon?: any;
  text: string;
  link: string;
  isActive: boolean;
}) => {
  return (
    <Link to={link}>
      <div
        className={`px-[5px] py-[12px] rounded-[5px] ${
          isActive ? "bg-bg01" : ""
        } flex flex-row justify-center`}
      >
        {Icon ? (
          <Icon width={22} height={22} className="text-secondary" />
        ) : null}
        <span className="text-white">{text}</span>
      </div>
    </Link>
  );
};
